import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué es exactamente Clave de Paz?',
  a: 'Es un ebook digital (PDF) de 20 páginas con protocolos concretos para comunicarte con tu ex sin escalar conflictos y proteger a tus hijos.'
}, {
  q: '¿Esto sirve si mi ex es narcisista o muy agresivo?',
  a: 'Sí, especialmente en esos casos. El método se basa en quitarle el combustible emocional que necesitan para seguir el conflicto.'
}, {
  q: '¿No es muy frío hablarle así al padre/madre de mis hijos?',
  a: 'Es profesional, no frío. La comunicación logística protege a tus hijos del fuego cruzado. Ellos lo van a agradecer.'
}, {
  q: '¿Cuánto tiempo me lleva leerlo?',
  a: 'Es una lectura rápida de 20 páginas. Podés leerlo en una tarde y empezar a aplicar los protocolos ese mismo día.'
}, {
  q: '¿Tengo que instalar alguna aplicación?',
  a: 'No. Son protocolos mentales y de redacción que aplicás directamente en tu WhatsApp o cualquier medio que uses para comunicarte.'
}, {
  q: '¿Qué pasa si mi ex me pide explicaciones por mis respuestas cortas?',
  a: 'El manual incluye cómo manejar esa transición y dejar el límite claro sin generar un nuevo conflicto.'
}, {
  q: '¿Es un libro físico?',
  a: 'No. Es un ebook digital en formato PDF. Lo descargás inmediatamente después del pago y lo podés leer en tu celular, tablet o computadora.'
}, {
  q: '¿Cómo recibo el producto después de pagar?',
  a: 'Inmediatamente después del pago, recibís un email con el enlace de descarga. El acceso es instantáneo.'
}, {
  q: '¿Esto reemplaza la terapia o el asesoramiento legal?',
  a: 'No. Este material es educativo e informativo. Complementa pero no reemplaza el trabajo con profesionales de salud mental o abogados.'
}, {
  q: '¿Puedo compartirlo con mi ex?',
  a: 'El manual está pensado para tu uso personal. Si tu ex también quiere aplicar estos protocolos, puede adquirir su propia copia.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-navy py-24 px-6" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-80">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white" data-id="element-81">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-84">
                <span className="font-bold text-navy text-lg pr-4" data-id="element-85">
                  {faq.q}
                </span>
                <ChevronDown className={`flex-shrink-0 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 text-slate-600 text-lg border-t border-slate-100 pt-3" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}